export default __webpack_public_path__ + "static/media/instagramWhite.28628bf6.svg";